/** Stored phone format (PL-2): E.164 Ethiopian mobile number. */
export const PHONE_E164_REGEX = /^\+251[79]\d{8}$/;

/**
 * PL-2: accepts 09XXXXXXXX, 07XXXXXXXX, 9XXXXXXXX, 7XXXXXXXX, 2519XXXXXXXX, +2519XXXXXXXX
 * (and the 7 variants, plus 00251…). Returns "+2519XXXXXXXX" or null.
 */
export function normalizeEthiopianPhone(input: string): string | null {
  const s = input.trim().replace(/[\s\-().]/g, '');
  const patterns = [/^0([79]\d{8})$/, /^([79]\d{8})$/, /^251([79]\d{8})$/, /^\+251([79]\d{8})$/, /^00251([79]\d{8})$/];
  for (const p of patterns) {
    const m = p.exec(s);
    if (m) return `+251${m[1]}`;
  }
  return null;
}

/** "+251911223344" → "0911 22 33 44" for display. */
export function formatPhone(e164: string | null | undefined): string {
  if (!e164) return '';
  const m = /^\+251(\d{3})(\d{2})(\d{2})(\d{2})$/.exec(e164);
  return m ? `0${m[1]} ${m[2]} ${m[3]} ${m[4]}` : e164;
}
